export default __webpack_public_path__ + "static/media/guthree.0bd7eef9.gif";